import { render, staticRenderFns } from "./multi-account-cbr-dialog.vue?vue&type=template&id=b8913a38"
import script from "./multi-account-cbr-dialog.vue?vue&type=script&lang=js"
export * from "./multi-account-cbr-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports